import { ReactElement } from 'react';

import { GridContainer } from './GridContainer';
import { GridItem } from './GridItem';
import styles from './styles.module.scss';

import { Widgets } from ':components/Widgets';
import { containersConfig } from ':constants';

export function Dashboard(): ReactElement {
  return (
    <div className={styles.gridContainer}>
      {containersConfig.map(
        ({ id, width_large, width_medium, width_small, name }) => (
          <GridItem
            key={id}
            lg={width_large}
            md={width_medium}
            sm={width_small}
          >
            <GridContainer containerName={name} />
          </GridItem>
        ),
      )}
      <Widgets />
    </div>
  );
}
